import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import { ErrorCode } from 'redux/modules/application/reducers/error';
import Field from 'components/Form/Field';
import { LegalInvestigationsForeignItemModel } from 'forms/sections/legal/investigation/foreign/types';
import Branch from 'components/Form/Branch';
import Country from 'components/Form/Country';

interface Props extends Partial<LegalInvestigationsForeignItemModel>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
}

export default class ForeignInvestigationItem extends ValidationElement<Props> {
  update = (queue: Partial<LegalInvestigationsForeignItemModel>) => {
    this.props.onUpdate({
      ForeignGovernment: this.props.ForeignGovernment,
      Granted: this.props.Granted,
      ...queue,
    });
  };

  updateForeignGovernment = (values: LegalInvestigationsForeignItemModel['ForeignGovernment']) => {
    this.update({
      ForeignGovernment: values
    });
  };

  updateGranted = (values) => {
    this.update({
      Granted: values,
    });
  };

  render() {
    const attribute = `List.items[${this.props.$index}].Item`;
    return (
      <div>
        <Field
          title={i18n.t('legal.pvq.investigations.foreign.heading.foreignGovernment')}
          adjustFor="big-buttons"
          scrollIntoView={this.props.scrollIntoView}
          attribute={`${attribute}.ForeignGovernment`}
        >
          <Country
            {...this.props.ForeignGovernment}
            attribute={`${attribute}.ForeignGovernment`}
            name="ForeignGovernment"
            className="foreign-government"
            onUpdate={this.updateForeignGovernment}
            onError={this.props.onError}
            required={this.props.required}
            excludeUnitedStates
          />

        </Field>

        <Branch
          {...this.props.Granted}
          name="granted"
          label={i18n.t('legal.pvq.investigations.foreign.heading.granted')}
          labelSize="h4"
          className="legal-investigations-foreign"
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateGranted}
          scrollIntoView={this.props.scrollIntoView}
          attribute={`${attribute}.Granted`}
          showDNK
        />
      </div>
    );
  }
}

ForeignInvestigationItem.defaultProps = {
  onUpdate: (queue) => { },
  onError: (value, arr: ErrorCode[]) => arr,
  ForeignGovernment: {},
  Granted: {},
};
